import React, {useRef, useCallback, useState, useEffect} from "react"
import BasicButton from "./BasicButton";
import TextInput from "./TextInput";

export default function DropdownMenu(props) {
    const [selected, setSelected] = useState(props.currentValue || null)
    const [manualValue, setManualValue] = useState((props.manualInput && props.manualInput.value) || null)
    const [checked, setChecked] = useState(props.checked || false)
    const [classes, setClasses] = useState("ui-dropdown-down")
    const [style, setStyle] = useState(null)
    const [listedValues, setListedValues] = useState(props.values || [])
    const [filterText, setFilterText] = useState(null)
    let _timeOutId = null
    let _debug = 0 //add debug list items number, 0 for disable debug

    useEffect(() => {
        setSelected(props.currentValue)
    }, [props.currentValue])

    useEffect(() => {
        setListedValues(props.values)
    }, [props.values])

    //https://medium.com/@teh_builder/ref-objects-inside-useeffect-hooks-eb7c15198780
    function useHookWithRefCallback() {
        const ref = useRef(null)
        const setRef = useCallback(node => {
            // if (ref.current) {
            //     //Make sure to cleanup any events/references added to the last instance
            // }
            if (node) {
                const viewHeight = document.documentElement.scrollHeight
                let cssclass = "ui-dropdown-down"
                let style = null
                const dropdownBound = node.getBoundingClientRect().height;
                const pos = {
                    y: window.pageYOffset + node.getBoundingClientRect().top
                }
                if (pos.y + dropdownBound >= viewHeight) {
                    cssclass = "ui-dropdown-up"
                }
                if(cssclass !== "ui-dropdown-down" && pos.y - dropdownBound <= 50){
                    cssclass = "ui-dropdown-center"
                    style = {
                        top: -(pos.y - window.scrollY - 40),
                        height: window.innerHeight - 10
                    }
                    if(dropdownBound <= style.height){
                        style.height = 'auto';
                    }
                }
                setClasses(cssclass)
                if(style) setStyle(style)

                //Here do scroll to selected element
                let offsetBoy = Array.from(node.children).filter(c=>{
                    return c.className.length > 1//__scrolloffset class used only for this
                })
                if(offsetBoy.length > 0 && offsetBoy[0].offsetTop){
                    node.scroll(0, offsetBoy[0].offsetTop - 5)//mumbo jumbo offset, same size as spacing * 0.5
                }
            }
            // Save a reference to the node
            ref.current = node
        }, [])
        return [setRef]
    }

    function openDropdownMenu(){
        setClasses("ui-dropdown-down opening")
        _timeOutId = setTimeout(()=>{
            setStyle(null)
            setClasses("ui-dropdown-down")
            setChecked(true)
            handleFocus()
            if(props.openDropdownCallback) props.openDropdownCallback()
        }, 50)
    }

    function closeDropdownMenu(){
        setClasses("ui-dropdown-down closing")
        setStyle(null)
        setClasses("ui-dropdown-down")
        setChecked(false)
        setFilterText(null)
        setListedValues(props.values)
        handleFocus()
        if(props.closeDropdownCallback) props.closeDropdownCallback()
    }

    function onBlur(evt){
        const currentTarget = evt.currentTarget
        if (!currentTarget.contains(document.activeElement)) {
            _timeOutId = setTimeout(()=> {
                closeDropdownMenu()
            }, 20)
        }
    }

    function handleFocus(){
        _timeOutId = clearTimeout(_timeOutId)
    }

    function findSelectedbyValue(){
        let retObj = {}
        props.values.forEach(obj => {
            if(obj.value != null && obj.value === selected) retObj = obj
        })
        return retObj
    }

    function renderSearchInput(){
        if(!props.showFilter) return null
        return <TextInput
            type={"search"}
            value={filterText}
            onChange={(val)=> {
                setFilterText(val)
                let filter = val.toLowerCase()
                setListedValues(props.values.filter((item, i) => item.text.toLowerCase().includes(filter)))
            }}
            placeholder={"Suodata listaa"}
        />
    }

    const title = typeof props.text === 'boolean' ? null : (props.text || 'Valitse') //settings prop text true will remove text
    let typeslist = [], hiddenItem = title//longest text in list to make dropdown same width as content
    let menuValues = listedValues

    //If empty value is set assign it to values as first item
    if(props.emptyValue){
         if(menuValues[0] !== props.emptyValue) menuValues.unshift(props.emptyValue)
    }
    let tag = null
    if(props.tag){
        tag = <i className={"ui-icon ui-icon-xs ui-icon-semantic-disc ui-icon_color-main info-tag"}>{props.tag}</i>
    }

    let isRequired = props.required && (!findSelectedbyValue() || !manualValue)
    //if props element is set, it will completely override child
    menuValues.forEach(function(v, i){
        const isSelected = (props.currentValue && props.currentValue === v.value && v.value != null)
            || (v.selected && v.selected != null && !v.value)
        if((!props.hideTexts && props.text && v.text?.length > hiddenItem?.length) && !props.staticMenu) hiddenItem = v.text
        if(Object.keys(v).length < 1) return//skip if object empty (especially used in dropdowns)
        typeslist.push(<li
                key={'typeslist__' + v.value + i}
                className={(v.className ? v.className + " " : "") + (v.selected || selected === v.value ? "__scrolloffset" : "")}
                role="option"
                aria-selected={isSelected}
            >
            {v.element ||
                <BasicButton
                    label={!props.hideTexts ? v.text : null}
                    value={v.value}
                    disabled={v.disabled || ((typeof v.value !== 'number' && !v.value) && !v.action)}//Obscure custom logic here, check it later
                    selected={isSelected}
                    btnType={v.btnType || null}
                    btnClass={v.btnClass || null}//used only in Sidebar dropdown
                    action={()=> {
                        if(typeof v.action === "function"){
                            v.action(v.value)//if callback is set, then ummm do it.
                            setSelected(null)
                            closeDropdownMenu()
                        }else{
                            props.onSelect(v.value)
                            setSelected(v.value)
                            closeDropdownMenu()
                        }
                        setManualValue(null)
                        if(v.selected || selected) isRequired = false
                    }}
                    icon={v.icon || null}
                    customTag={props.customTag}
                    notifMsg={v.notifMsg}
                />}
        </li>)
    })
    if(props.manualInput){
        const inputElement = <TextInput
            type={props.manualInput.type || null}
            label={props.manualInput.title}
            labelCSS={"text-sm"}
            value={manualValue}
            placeholder={props.manualInput.placeholder || null}
            onKeyUp={(evt)=>{
                setSelected(null)
                if (evt.key === 'Enter') {
                    if (typeof props.manualInput.onValueSubmit === 'function') props.manualInput.onValueSubmit(manualValue)
                    closeDropdownMenu()
                    return
                }
                setManualValue(evt.target.value)
                if (props.manualInput.onValueChange &&
                    typeof props.manualInput.onValueChange === 'function') props.manualInput.onValueChange(evt.target.value)
            }}
        />
        typeslist.push(<li key={"dropdownmenu__manualinput"} className={"manual-item"}>{inputElement}</li>)
    }
    const [ref] = useHookWithRefCallback()

    if(!!_debug){
        new Array(_debug).fill().forEach((e, i) => typeslist.push(<li key={"debug__" + i}>
                <BasicButton
                    label={"debug item " + i}
                    value={"debug__" + i}
                />
            </li>)
        )
    }

    let btnLabel = !props.hideTexts ? (findSelectedbyValue().text || (props.text || title)) : null

    return <div
            tabIndex={0}
            onBlur={onBlur}
            onFocus={handleFocus}
            className={"ui-dropdown " + classes + (props.className ? " " + props.className : "")}
        >
            <BasicButton
                btnClass={props.btnClass || "2nd"}
                label={!props.disableLabelOnSelect ? btnLabel : null}
                icon={props.icon || null}
                action={()=>{
                    if(checked){
                        closeDropdownMenu()
                    }else{
                        openDropdownMenu()
                    }
                }}
                title={!props.tooltip && title}
                disabled={props.disabled}
                notifMsg={props.notifMsg}
                tooltip={props.tooltip && !checked ? props.tooltip : null}
                selected={checked || props.active}
                btnType={props.btnType || null}
                size={props.btnSize}
                required={isRequired}
                className={props.hideArrow ? "padding-0" : null}
                customTag={props.customTag}

                aria-expanded={checked}
                aria-labelledby="select button"
                aria-haspopup="listbox"
                aria-controls="select-dropdown"
                role="combobox"
            >
                {!props.hideArrow ? <i className={"ui-icon ui-icon-sm ui-icon-chevron-" + (checked ? "up" : "down") + (props.btnClass === "primary" ? " ui-icon_color-light" : "")} title="Avaa valikko"/> : null}
            </BasicButton>
            {tag}
            {checked ? <ul
                ref={ref}
                className="ui-dropdown-menu"
                style={style}
                role="listbox"
            >
                {renderSearchInput()}
                {typeslist}</ul> : null}
            {hiddenItem !== '' ? <div>{hiddenItem}</div> : null}
        </div>
}

//Will be added later for multiselect
// export function ListBox(props) {
//     const [selectedValues, setSelectedValues] = useState(props.selectedValues)
//     return <DropdownMenu
//         values={props.values}
//         selectedValues={selectedValues}
//     />
// }